import loadable from "@loadable/component";

const ActivityTableComponent = loadable(
  () => import("../../components/ActivityLog/Timeline")
);

export default function ActivityLogList() {
  return <ActivityTableComponent />;
}
